import { Entry } from 'types/entry'
import * as constants from 'actions/constants'
import { InteractionType } from 'types/interactions'
import { arrayRemove, removeEntryFromArrayById } from 'helpers/array'

interface ProfileListMapElement {
  createdAt: string,
  interaction: InteractionType
}

type FriendList = {
  [key: string]: ProfileListMapElement[]
}

export interface ActivityReducer {
  likedEventsIds: string[]
  likedCommunitiesIds: string[]
  friendList: FriendList
  attendingEventsIds: string[]
  followedUsers: string[]
  blockedUsers: string[]
  seenEntries: Map<string, Date>
}
const defaultState: ActivityReducer = {
  // activity: null,
  likedEventsIds: [],
  likedCommunitiesIds: [],
  attendingEventsIds: [],
  followedUsers: [],
  friendList: {},
  blockedUsers: [],
  seenEntries: new Map()
}

let activityObject = { ...defaultState } //FOR EDITING

export default function ActivityReducer(state: ActivityReducer = defaultState, action: any) {
  switch (action.type) {

    case constants.FRIEND_INTERACTION_RESPONSE:
      if (!action.response.success) return state;
      if (!action.response.activity) return state;
      return Object.assign({}, state, {
        friendList: action.response.activity.friendList
      })

    // const friendList = state.friendList instanceof Map ? new Map(state.friendList) : new Map<string, ProfileListMapElement[]>();
    // const uid = action.response.uid
    // if (friendList.get(uid) === undefined) friendList.set(uid, [])
    // const prevInteractions = friendList.get(uid);
    // if (!prevInteractions) return state;
    // friendList.set(uid, [...prevInteractions, action.response.interaction])

    // return Object.assign({}, state, {
    //   friendList: friendList
    // })

    case constants.GET_MY_ACTIVITY_RESPONSE:
      // activityObject = { ...action.response.activity }
      // const temp: ProfileListMap = new Map();
      // for (const e in activityObject.friendList) {
      //   temp.set(e, activityObject.friendList[e])
      // }
      // activityObject.friendList = temp;
      // return activityObject
      if (!action.response.success) return state
      return Object.assign({}, state, {
        friendList: action.response.activity?.friendList,
        likedEventsIds: action.response.activity?.likedEventsIds,
        attendingEventsIds: action.response.activity?.attendingEventsIds,
        followedUsers: action.response.activity?.followedUsers,
        blockedUsers: action.response.activity?.blockedUsers,
        likedCommunitiesIds: action.response.activity?.likedCommunitiesIds,
      })

    case constants.FOLLOW_USER_RESPONSE:
      return action.response.success
        ? Object.assign({}, state, { followedUsers: action.response.followedUsers })
        : state

    case constants.BLOCK_USER_TOGGLE_RESPONSE:
      return action.response.success
        ? Object.assign({}, state, { blockedUsers: action.response.blockedUsers })
        : state

    case constants.LIKE_EVENT_RESPONSE:
      activityObject = { ...state }
      if (activityObject.likedEventsIds === undefined) activityObject.likedEventsIds = []
      if (action.response.success) {
        if (action.newState) {
          activityObject.likedEventsIds.push(action.eventId)
        }
        else {
          activityObject.likedEventsIds = arrayRemove(activityObject.likedEventsIds, action.eventId)
        }
      }
      return activityObject

    case constants.LIKE_COMMUNITY_RESPONSE:
      activityObject = { ...state }
      if (activityObject.likedCommunitiesIds === undefined) activityObject.likedCommunitiesIds = []
      if (action.response.success) {
        if (action.newState) {
          activityObject.likedCommunitiesIds.push(action.communityId)
        }
        else {
          activityObject.likedCommunitiesIds = arrayRemove(activityObject.likedCommunitiesIds, action.communityId)
        }
      }
      return activityObject

    case constants.ATTEND_EVENT_RESPONSE:
      activityObject = { ...state }
      if (activityObject.attendingEventsIds === undefined) activityObject.attendingEventsIds = []
      if (action.response.success) {
        if (action.newState) {
          activityObject.attendingEventsIds.push(action.eventId)
        }
        else {
          activityObject.attendingEventsIds = arrayRemove(activityObject.attendingEventsIds, action.eventId)
        }
      }
      return activityObject

    case constants.GET_LATEST_POSTS_RESPONSE:
      if (action.response.success) {
        activityObject = { ...state }
        activityObject.seenEntries = activityObject.seenEntries ? new Map(Object.entries(activityObject.seenEntries)) : new Map();
        const date = new Date()
        if (activityObject.seenEntries === undefined)
          activityObject.seenEntries = new Map()
        for (let entry of action.response.entries) {
          activityObject.seenEntries.set(entry.id, date)
        }
        return activityObject
      }
    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      if (action?.type === 'LOGOUT') return defaultState
      return state
  }
}
